import axios from '@/axios.js'

export default {
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.apiRobocob}/getContactList`)
        .then((response) => {
          //console.log(response.data)
          commit('SET_USERS', response.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser (context, id) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.apiRobocob}/getClient`, {cli_id: id})
        .then((response) => {
          //console.log(response)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.apiRobocob}/deleteContactClient`, {cli_id : id})
        .then((response) => {
          commit('REMOVE_RECORD', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  sendTemplateMessage (context, id) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.apiRobocob}/reestarClientFlow`, {cli_id : id})
        .then((response) => {
          //console.log(response);
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
